// The following declaration can't be moved to index.d.ts because we get a compmile error
declare global {
  interface Window {
    jwplayer?: any;
    browserProductViewTrackData?: {
      product_id: number;
      version_number: number;
      search_id: number;
    };
  }
}

export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  /** An encoded date */
  Date: any;
  /** An encoded datetime */
  DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
};

export type IAccount = {
  // FIXME: camel case
  considered_new_user: boolean;
  display_name: string;
  email: string;
  first_name: string;
  full_name: string;
  hashed_id: string;
  hashedId?: string;
  last_name: string;
  eligible_credits_balance_in_cents: number;
  fod_eligible: boolean;
  reward_points: number;
  meta_store: {
    account_id: number;
    number_of_completed_orders: number;
    number_of_used_states: number;
    number_of_used_products: number;
    number_of_used_merchants: number;
    number_of_sent_gifts: number;
    number_of_sent_cities: number;
    used_state_counts: Array<[string, number]>;
    completed_shipments: IShipment[];
  };
};

export type IAccountV2 = {
  loading?: boolean;
  consideredNewUser: boolean;
  displayName: string;
  email: string;
  firstName: string;
  fullName: string;
  hashedId: string;
  lastName: string;
  eligibleCreditsBalanceInCents: number;
  fodEligible: boolean;
  rewardPoints: number;
  metaStore: {
    accountId: number;
    numberOfCompletedOrders: number;
    numberOfUsedStates: number;
    numberOfUsedProducts: number;
    numberOfUsedMerchants: number;
    numberOfSentGifts: number;
    numberOfSentCities: number;
    usedStateCounts: Array<[string, number]>;
    completedShipments: IShipment[];
  };
};

export type IAccountMeta = {
  identify_traits: {
    'Goldbely Visitor Tracking Code': string;
    'Goldbely Hashed Account Id': string;
    email_identity_id: string;
    first_name: string;
    last_name: string;
    md5_email: string;
    email: string;
  };
  ecommerce_properties: {
    cart_id: string;
    products: Array<IProduct>;
  };
};

export type IAdmin = {
  id: number;
  name: string;
};

export type IAdminToolsItem = {
  name: string;
  items: Array<{
    dataMethod?: string;
    name: string;
    link: string;
    rel?: string;
  }>;
};

export type IAvailableOption = {
  addToCart: boolean;
  gbFormFieldLabel: string;
  gbFormFieldValue: number;
  hasPriceAdj: boolean;
  isDefault: boolean;
  priceAdjInCents: number;
  value: string;
};

export type IIdealDeliveryCalendarSetting = {
  id?: number;
  banner?: string;
  body: string;
  bodyBelow?: string; // deprecated
  colorOne: string;
  colorTwo: string;
  endsOn?: string;
  headline: string;
  headlineColor?: string;
  datesHighlighted?: string;
  name?: string;
  preview?: boolean;
  startsOn?: string;
  showGift?: boolean;
};

export type ISeoContentSection = {
  title: string;
  subtitle: string;
  body: string;
};

export type IAvailableVariance = {
  availableOptions: IAvailableOption[];
  gbLabel: string;
  formField: string;
  hasHardcodedOption: boolean;
  delimiter: string;
  splitForDisplay: boolean;
  displayMode?: 'dropdown' | 'inline';
};

export type ITVVideo = {
  id: number;
  active: boolean;
  clipMediaId?: string;
  duration?: string;
  landscapeMediaId: string;
  outroSeconds: number;
  merchantId?: number;
  metaDescription: Maybe<string>;
  metaKeywords: Maybe<string>;
  metaTitle: string;
  portraitClipPlayDuration?: number;
  portraitClipStartTime?: number;
  portraitMediaId?: string;
  preview: boolean;
  productId?: number;
  productCardShowInSeconds: number;
  slug: string;
  title: string;
};

export type ITVVideoPlaylist = {
  id: number;
  description: string;
  heroImageUrl: string;
  metaDescription: Maybe<string>;
  metaKeywords: Maybe<string>;
  metaTitle: string;
  slug: string;
  title: string;
  videos: ITVVideo[];
};

export type IWebCard = {
  id?: string;
  call_to_action?: string;
  className?: string;
  card_type?: string;
  content?: string;
  image_url?: string;
  mobile_image_url?: string;
  linkable_type?: 'collection' | 'category' | 'merchant';
  linkable_id?: string;
  linkable_subtype?: string;
  linked_entity?: {
    title?: string;
    permalink?: string;
  };
  path?: string;
  permalink?: string;
  styles?: {
    base?: { [key: string]: string };
    title?: { [key: string]: string };
  };
  title: string;
  video_url?: string | null;
};

export type IWebHomepage = {
  customer_reviews: any[];
  hero: any; // FIXME!
  hero_card: IWebCard;
  banner_cards: IWebCard[];
  hero_cards: IWebCard[];
  huge_cards: IWebCard[];
  short_cards: IWebCard[];
  instagram_posts: any[]; // FIXME!
  title: Maybe<string>;
  top_collections: any[]; // FIXME!
  video: any; // FIXME!
  new_hero_card: IWebCard;
  new_categories_cards: IWebCard[];
  new_huge_cards: IWebCard[];
  new_short_one_cards: IWebCard[];
  new_short_two_cards: IWebCard[];
  new_short_three_cards: IWebCard[];
  new_press_cards: IWebCard[];
  new_social_cards: IWebCard[];
  new_best_seller_cards: IWebCard[];
};

export type IWebMediaAsset = {
  id: number;
  imageUrl?: string;
  imageAlt?: string;
  videoFullUrl?: string;
  videoPreviewImageUrl?: string;
};

export type IMerchantReview = {
  id: string;
  bodyHtml: string;
  createdAt: string;
  customerName: string;
  location: string;
};

export type IShipment = {
  from: IShipmentLocation;
  to: IShipmentLocation;
  carrier: string;
  distance: string;
};

type IShipmentLocation = {
  latitude: number;
  longitude: number;
  city: string;
};

export type IShipper = {
  city: string;
  state: string;
};

export type IMerchant = {
  id: number;
  alternateShippingLocationNotice: boolean;
  customerRating?: number;
  defaultProductSorting?: string;
  displayRecommendedOnPdp?: boolean;
  foodMakerImageUrl?: string;
  isShippingIncluded: boolean;
  isSoldOut: boolean;
  location: string;
  loveScore?: number | null;
  mainImageUrl: string;
  marginInPercent: string;
  name: string;
  nps?: number | null;
  npsSampleSize?: number | null;
  permalink: string;
  publishedReviews: IMerchantReview[];
  profile?: string;
  shipper: IShipper;
  shortName?: string;
  showcaseVideo: {
    videoId: string | null;
  };
  starShipper: boolean;
  state: string;
  statePermalink: string;
  swappableProductOptions: boolean;
  tagline?: string;
  videoId: string | null;
  videoPartial: string | null;
  webMediaAsset?: {
    videoPreviewImageUrl?: string;
    videoPreviewUrl?: string;
  };
  whoElseLovesIt?: string;
};

export type IBadge = {
  id: number;
  name:
    | 'gb_top_gifts'
    | 'gorgeous_box'
    | 'james_beard'
    | 'michelin_bib_gourmand'
    | 'michelin_star'
    | 'editor_pick';
  displayName?: string;
};

export type IPromotionProductPromotion = {
  id: number;
  description: string;
  discountCode: string;
  discountInCents: number | null;
  discountInPercent: number;
  discountInPercentWithDecimal: string;
  expiresAt: Scalars['DateTime'];
  forFlashSale: boolean;
  startsAt: Scalars['DateTime'];
};

export type IPromotionProduct = {
  id: number;
  afterPromotionProductPriceInCents: number;
  endsAt: Scalars['DateTime'];
  promotion: IPromotionProductPromotion;
  startsAt: Scalars['DateTime'];
};

export type IProduct = {
  id: number;
  acceptsRequestedDeliveryDate: boolean;
  almostSoldOut: boolean;
  availableForPickUp: boolean;
  availableVariances: IAvailableVariance[];
  badges?: IBadge[];
  buyNowEnabled?: boolean;
  canAddToCart: boolean;
  customerInstructionProductUrl?: string;
  defaultQuantity?: number;
  delayed: boolean;
  descriptionHtml: string;
  discountedPriceInCents?: number;
  displayDiscountPricing?: boolean;
  displayPrice: number;
  displayServingLabel?: string;
  displayServingSize?: string;
  displayServingUnit?: string;
  earliestDeliveryDate?: string;
  editorPick?: boolean;
  effectiveMainImageUrl?: string;
  effectiveMainVideoUrl?: string;
  effectiveMetaDescription?: string;
  effectiveName: string;
  effectivePriceInCents: number;
  effectiveQuantityLabel: string;
  freeShipping: boolean;
  hasAvailableOptions?: boolean;
  hasGbTvVideo: boolean;
  hasMultipleSpeeds?: boolean;
  instructionVideoImageUrl?: string;
  instructionVideoUrl?: string;
  isEgiftable?: boolean;
  isEgiftCard?: boolean;
  isNew: boolean;
  isRecurringSubscription?: boolean;
  isSubscribable: boolean;
  liveClass?: ILiveClass;
  liveClassId?: number;
  mediaAssets: IWebMediaAsset[];
  merchant: IMerchant;
  moreDetailsHtml?: string;
  noPromotionsAllowed: boolean;
  numberOfShippingDays: number;
  permalink: string;
  priceInCents: number;
  priceSubheading?: string;
  productIngredientsHtml?: string;
  productType?: string;
  promotionProducts: IPromotionProduct[];
  publishedReviews?: IMerchantReview[];
  saleEndsAt?: string;
  shippingDetailsHtml?: string;
  showGbVideo?: boolean;
  sku: number;
  soldOutReason: string;
  tvVideo?: ITVVideo;
  useAndCareHtml?: string;
  videoId?: string;
  videoPartial?: string;
};

export type ICartItem = {
  id?: number;
  customerChoices?: {
    [variant: string]: string;
  };
  dataForAnalytics?: any;
  possibleQuantities: Array<{
    label: string;
    value: number;
  }>;
  product: IProduct;
  productId: number;
  purchaseButtonText: string;
  purchaserEmail?: string;
  quantity: number;
  totalInCents?: number;
};

export type GiftCardProduct = {
  description: string;
  id: number;
  priceInCents: number;
  soldOut?: boolean;
  data?: any;
};

export type IMegaphone = {
  backgroundColor?: string;
  description?: Maybe<string>;
  expiresAt?: Maybe<string>;
  icon?: Maybe<string>;
  id: number;
  megaphoneType: 'status' | 'marketing';
  regexes: string[];
  textColor?: string;
  title?: Maybe<string>;
};

export type INavItem = {
  children?: INavItem[] | null;
  external?: boolean;
  featuredImageUrl?: string;
  id: number;
  title: string;
  turbolinksDisabled?: boolean;
  url?: string;
};

export type INextShippingOption = {
  deadlineAt: string;
  estimatedDeliveryOn: string;
  isGround: boolean;
  toShipOn: string;
};

/** All enums used by types */
export enum ILiveClassSectionType {
  Allergens = 'allergens',
  AfterClassNotes = 'after_class_notes',
  ClassInstructions = 'class_instructions',
  ClassPrep = 'class_prep',
  ItemsIncluded = 'items_included',
  ServingSize = 'serving_size',
  ThingsToBuy = 'things_to_buy',
  UnpackingInstructions = 'unpacking_instructions',
}

export enum ILiveClassMeetingPlatform {
  Zoom = 'zoom',
  GoogleMeet = 'google_meet',
}

/** API Types */
export type ILiveClass = {
  id: Scalars['ID'];
  chefImageUrl: string;
  chefLocation: string;
  chefName: string;
  classLimit: number;
  deadlineAt: Scalars['Date'];
  duration: string;
  effectiveMainImageUrl?: string;
  effectiveName: string;
  foodArrivesOn: Scalars['Date'];
  hostedBy: string;
  isSoldOut: boolean;
  meetingId: string;
  meetingPlatform: ILiveClassMeetingPlatform;
  meetingUrl: string;
  merchant: IMerchant;
  moderatedBy: string;
  permalink: string;
  prepTime: Maybe<string>;
  product?: IProduct;
  welcomeMessage?: string;
  workshopAt: Scalars['DateTime'];
  // Associations
  sections: ILiveClassSection[];
};

export type ILiveClassSection = {
  id: Scalars['ID'];
  body: string;
  sectionType: ILiveClassSectionType;
};

export type IAppliedGiftCard = {
  code: string;
  appliedAmmountInCents: number;
  description: string;
};

export type IDiscountCode = {
  action: 'add' | 'delete';
  code: string;
  type?: 'discount_code' | 'gift_card';
};

export type IDiscountCodes = {
  promoCode: {
    code: string;
    value: number;
  };
  appliedGiftCards: IAppliedGiftCard[];
};

export type ICartV2AggregatedTotals = {
  appliedAccountCreditsInCents: number;
  cartItemsSubtotalInCents: number;
  giftCardDiscountInCents: number;
  importShippingSurchargeSubtotalInCents?: number;
  promotionDiscountInCents: number;
  shippingSubtotalInCents: number;
  taxesTotalInCents: number;
  subtotalInCents: number;
  totalInCents: number;
  totalInPoints: number;
};

export const STORED_PAYMENT_METHOD = 'stored_payment_method';
export const INTENTS_PAYMENT_METHOD = 'cc_imprint_payment_method';

export type StoredPaymentMethod = {
  id: number;
  cardType: string;
  lastFour: string;
  type?: string;
};

export type PromoRedemption = {
  id?: number;
  action?: 'add' | 'delete';
  applicable?: boolean;
  discountInCents?: number;
  errors?: string[];
  priceInPoints?: number;
  promotionDescription?: string;
  rewardPromotionId?: number;
  promotionId?: number;
};

export type PaymentMethodType =
  | 'card'
  | 'paypal'
  | 'apple_pay'
  | 'cashapp'
  | 'klarna'
  | 'google_pay'
  | 'stored_payment_method';

export type PaymentMethod = {
  type: PaymentMethodType;
  storedPaymentMethod?: StoredPaymentMethod;
  cvc?: string;
};

export type ICartV2 = {
  accountHasBeenPotentiallyCompromised: boolean;
  aggregatedTotals: ICartV2AggregatedTotals;
  allowMultiRecipient: boolean;
  cart?: {
    id: number;
  };
  deliveryAddress: ICartDeliveryAddress;
  giftCards: ICartGiftCard[];
  discountCodes?: IDiscountCodes;
  discountCode?: IDiscountCode;
  giftMessage: ICartGiftMessage;
  purchaserAccount?: Purchaser;
  purchaserEmail: string;
  recipient: ICartRecipient;
  subcarts: ISubCart[];
  totalInCents?: number;
  stripePaymentIntentClientSecret?: string;
  paymentMethods?: StoredPaymentMethod[];
  paymentMethodRequiresCvc?: boolean;
  promoRedemption?: PromoRedemption;
};

export type SavedAddressesResponse = {
  data: ICartDeliveryAddress[];
};

export type OrderMetaInformation = {
  message: string;
  severity: string;
};

export type OrderMeta = {
  information: OrderMetaInformation[];
};

export type OrderResponse = {
  data: ICartV2;
  meta: OrderMeta;
};

export type ICart = {
  aggregatedTotals: {
    appliedAccountCreditsInCents?: number;
    cartItemsSubtotalInCents?: number;
    giftCardDiscountInCents?: number;
    importShippingSurchargeSubtotalInCents?: number;
    promotionDiscountInCents?: number;
    shippingSubtotalInCents?: number;
    subtotalInCents?: number;
    taxesTotalInCents?: number;
    totalInCents?: number;
    totalInPoints?: number;
  };
  delivery_address?: ICartDeliveryAddress;
  deliveryAddress?: ICartDeliveryAddress;
  giftCards: Array<{
    from: string;
    id: number;
    messageToRecipient: string;
    pictureUrl: string;
    recipientEmail: string;
    senderEmail: string;
    title: string;
    to: string;
    valueInCents: number;
  }>;
  cart?: {
    id: number;
  };
  number_of_items: number;
  numberOfItems: number;
  order_total_after_discounts_and_gift_card_before_shipping_in_cents?: number;
  orderTotalAfterDiscountsAndGiftCardBeforeShippingInCents?: number;
  purchased_egift?: IEGift;
  purchasedEgift?: IEGift;
  purchaserEmail?: string;
  purchaserFirstName?: string;
  purchaserLastName?: string;
  purchaserPhone?: string;
  recipient: {
    phone: string;
  };
  requires_billing_info: boolean;
  shippingSubtotalInCents: number;
  subcarts: ISubCart[];
  total_in_cents?: number;
  totalInCents?: number;
};

export type ICartDeliveryAddress = {
  id?: number;
  default?: boolean;
  city?: string;
  company?: string;
  country?: 'US' | 'CA';
  email?: string; // TODO Remove this once api/v2/saved_addresses is updated
  emails?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  postalCode?: string;
  state?: string;
  street1?: string;
  street2?: string;
};

export type ICartGiftCard = {
  id: number;
  title: string;
  pictureUrl: string;
  to: string;
  recipientEmail: string;
  from: string;
  senderEmail: string;
  messageToRecipient: string;
  toSendEmailAt?: string;
  valueInCents: number;
};

export type ICartGiftMessage = {
  body?: string;
  email?: string;
  enabled: boolean;
  from?: string;
  giftRecipientEmail?: string;
};

export type ICartRecipient = {
  emails: string;
  phone: string;
};

export type ISubCart = {
  id: number;
  earliestDeliveryDateAvailable?: string;
  preferredShippingOption?: any;
  productEffectiveName?: string;
  requestedDeliveryOn?: string;
  cartItems: Array<{
    id: number;
    orderId: number;
    name?: string;
    imageUrl?: string;
    quantity?: number;
    product: {
      id: number;
      isEgiftable: boolean;
      almostSoldOut: boolean;
      displayPrice: number;
      effectiveMainImageUrl: string;
      effectiveName: string;
      path: string;
      productType: string;
    };
  }>;
  merchants: Array<{
    id: number;
    name: string;
    path: string;
  }>;
};

export type IEGiftCartItem = {
  // TODO: Is this really a cart item or a product?
  id: number;
  effectiveMainImageUrl: string;
  effectiveName: string;
  merchantName: string;
  merchantPath: string;
  productId: number;
  productPath: string;
  customerChoices?: {
    [key: string]: string;
  };
};

export type IEGift = {
  egiftCartItems: IEGiftCartItem[];
  messageToRecipient: string;
  notifyOption: string;
  notifyAt: string;
  notifiedAt: string;
  purchaserEmail: string;
  purchaserName: string;
  recipientFirstName: string;
  recipientLastName: string;
  recipientEmail: string;
};

export type IEGiftRedemption = {
  deliveryAddress: ICartDeliveryAddress;
  egiftBalanceInCents: number;
  receivedEgift: {
    id: number;
    recipientEmail: string;
  };
  recipient: {
    phone: string;
  };
};

export type IDeliveryOption = {
  carrierLabel: string;
  deadlineAt: string;
  estimatedDeliveryDate: string;
  minPurchaseInCents: number;
  rateInCents: number;
  soldOut: boolean;
};

export type IDeliveryOptionV2 = {
  carrierLabel: string;
  deadlineAt: string;
  estimatedDeliveryDate: string;
  freeShipping?: boolean;
  label?: string;
  minPurchaseInCents: number;
  rateInCents: number;
  soldOut: boolean;
  standardShipping: boolean;
};

export type IDeliveryOptionWithSuborderID = {
  suborderId: number;
  deliveryOptions: IDeliveryOption[];
};

export type IDeliveryOptions = {
  deliveryOptions: IDeliveryOption[];
};

export type IDeliveryOptionsV2 = {
  deliveryCalendar: IDeliveryOptionV2[];
  standardShipping: IDeliveryOptionV2[];
};

export type IEGiftRedemptionShippingSuborder = {
  id: number;
  cartItems: Array<{
    id: number;
    product: {
      id: number;
      isEgiftable: boolean;
      almostSoldOut: boolean;
      displayPrice: number;
      effectiveMainImageUrl: string;
      effectiveName: string;
      path: string;
      productType: string;
    };
  }>;
  merchants: Array<{
    id: number;
    name: string;
    path: string;
  }>;
  productEffectiveName: string;
  requestedDeliveryOn?: string;
};

export type IEGiftRedemptionShipping = {
  deliveryOptions: IDeliveryOptionWithSuborderID[];
  order: IEGiftRedemption;
  suborders: IEGiftRedemptionShippingSuborder[];
};

export type IConfirmedOrder = {
  id: number;
  accountPhone: any;
  authMode?: 'signup' | 'login';
  atocTotalInCents: number;
  atocTotalInDollars: number;
  atocTotalInPoints: number;
  availableCartItems: any;
  billingPostalCode: string;
  cartItemsSubtotalInCents: number;
  deliveryCity: any;
  deliveryPostalCode: any;
  deliveryStreet2: any;
  deliveryState: any;
  deliveryStreet1: any;
  discountCode: any;
  discountInCents: number;
  email?: string;
  giftCards: any;
  guest?: boolean;
  orderTotalAfterDiscountsBeforeShippingInCents: number;
  orderType?: string;
  previousRewardsPoints: number;
  purchaserFirstName: string;
  purchaserLastName: string;
  purchaserPhone: string;
  secureSlug: string;
  shippingSubtotalInCents: number;
  taxesTotalInCents: number;
  undiscountedCartItemsSubtotalInCents: number;
};

export type OrderV3Response = {
  data: OrderV3;
};

export type OrderV3 = {
  atocTotalInPoints: number;
  customerCanLogin: boolean;
  purchaser: Purchaser;
};

export type Purchaser = {
  purchaserEmail: string;
  purchaserFirstName: string;
  purchaserLastName: string;
  purchaserPhone: string;
};

export type EmailAuthRequest = {
  email_auth: {
    email: string;
    password: string;
  };
};

export type IRewardPromo = {
  discount_in_cents?: number;
  discount_text?: string;
  id?: number;
  price_in_points?: number;
  promotion_id?: number;
};

export type ISearchAggregationBucket = {
  doc_count: number;
  key: string | number;
};

export type ISearchAggregations = {
  badges?: {
    buckets: ISearchAggregationBucket[];
  };
  categories?: {
    buckets: ISearchAggregationBucket[];
  };
  cuisine?: {
    buckets: ISearchAggregationBucket[];
  };
  earliest_delivery_date?: {
    value: string;
  };
  earliest_delivery_dates?: {
    buckets: ISearchAggregationBucket[];
  };
  editor_pick?: {
    buckets: ISearchAggregationBucket[];
  };
  free_shipping?: {
    buckets: ISearchAggregationBucket[];
  };
  has_gb_tv_video?: {
    buckets: ISearchAggregationBucket[];
  };
  max_price?: {
    value: number;
  };
  min_price?: {
    value: number;
  };
  nested_categories?: {
    inner?: {
      name?: {
        buckets: ISearchAggregationBucket[];
      };
    };
  };
  on_sale?: {
    buckets: ISearchAggregationBucket[];
  };
  product_tags?: {
    buckets: ISearchAggregationBucket[];
  };
  product_type?: {
    buckets: ISearchAggregationBucket[];
  };
  regions?: {
    buckets?: Array<{
      states?: {
        buckets: ISearchAggregationBucket[];
      };
    }>;
  };
  tags?: {
    buckets: ISearchAggregationBucket[];
  };
};

/** Shop By Region */
export type ICity = {
  id: number;
  categories?: Maybe<string[]>;
  excerpt?: Maybe<string>;
  name: string;
  regionSlug: string;
  slug: string;
  slogan?: Maybe<string>;
  state: IState;
  stateSlug: string;
};

export type IState = {
  abbrev: string;
  categories?: Maybe<string[]>;
  excerpt?: Maybe<string>;
  name: string;
  productsCount?: number;
  region: IRegion;
  slug: string;
  slogan?: Maybe<string>;
  topCities?: Maybe<ICity[]>;
};

export type IRegion = {
  abbrev: string;
  categories?: Maybe<string[]>;
  excerpt?: Maybe<string>;
  name: string;
  slug: string;
  slogan?: Maybe<string>;
  states?: IState[];
  topCities?: Maybe<ICity[]>;
};

/** Progress Meter */
export type IProgressMeterPhase = {
  name: string;
  label: string;
  date?: string;
};

export type IProductsAndVideosTrackingParams = {
  merchant_id: number;
  product_id: number;
  version: number;
  video_displayed?: boolean;
  video_id?: string;
};

export type ITrackingParams = {
  products_and_videos:
    | {
        [key: number]: IProductsAndVideosTrackingParams;
      }
    | IProductsAndVideosTrackingParams[];
};

export type IPromotion = {
  alt: string;
  image: string;
  link: string;
  position: number;
};
